import React from "react";
import Header from "./Header";
import ContractConfig from "../contract/config/ContractConfig";

export default function LayoutContractConfig() {
  return (
    <>
      <Header />
      <ContractConfig />
    </>
  );
}
